import React, { useState } from 'react';
import { Col } from 'antd';
import { useLocation } from 'react-router-dom';

import { Filter, Header, List } from '@/views/Bera/_components';
import { toInitialValues } from '@/views/Bera/_components/Filter/utils';
import { DEFAULT_PAGE_SIZE, FIRST_PAGE } from '@/views/Bera/constants';

import type { BeraJobSummaryListFilter } from '@/types/Bera';
import * as S from './styles';

export function Bera(): JSX.Element {
	const { search } = useLocation();

	const searchParams = new URLSearchParams(search);
	const filter = Object.fromEntries(searchParams.entries()) as BeraJobSummaryListFilter;

	const [page, setPage] = useState<number>(FIRST_PAGE);
	const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);

	const initialValues = toInitialValues(filter);

	function handlePageChange(nextPage: number) {
		setPage(nextPage);
	}

	function handlePageSizeChange(nextPageSize: number) {
		setPageSize(nextPageSize);
		setPage(FIRST_PAGE);
	}

	function handleFilter() {
		setPage(FIRST_PAGE);
	}

	return (
		<S.Container gutter={[0, 14]} justify="center">
			<Col span={24}>
				<Header />
			</Col>
			<Col span={24}>
				<Filter initialValues={initialValues} onFilter={handleFilter} />
			</Col>
			<Col span={24}>
				<List
					page={page}
					filter={filter}
					pageSize={pageSize}
					onPageChange={handlePageChange}
					onPageSizeChange={handlePageSizeChange}
				/>
			</Col>
		</S.Container>
	);
}
